import { render, staticRenderFns } from "./list-card.vue?vue&type=template&id=89b862a0&scoped=true"
import script from "./list-card.vue?vue&type=script&lang=js"
export * from "./list-card.vue?vue&type=script&lang=js"
import style0 from "./list-card.vue?vue&type=style&index=0&id=89b862a0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89b862a0",
  null
  
)

export default component.exports